import React, { useState, useEffect, useCallback } from 'react';
import { ArrowForward } from '@mui/icons-material';
import { Button, Container, Modal } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import animationData from '../Assets/Animation';
import Tour from '../Assets/tour.mp4'
import Lottie from 'lottie-react';

export default function ImageSlider() {
  const [videoOpen, setVideoOpen] = useState(false);
  const [images, setImages] = useState([]);
  const navigate = useNavigate();

  const fetchCraousel = useCallback(async () => {
    try {
      const response = await fetch(`/api/getCarousel`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ activeInactive: 1 }),
      });

      if (response.ok) {
        const Data = await response.json();
        setImages(Data);
      }
    } catch (error) {
      console.error("Carousel fetch error:", error);
    }
  }, []);

  useEffect(() => {
    fetchCraousel();
  }, [fetchCraousel]);

  return (
    <div className="bg-[#0177b5]">
      <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel" >
        <div className="carousel-inner">

          <div className="carousel-item active">
            <Container maxWidth="xl">
              <div className="row align-items-center py-5">

                <div className="col-lg-7 text-white space-y-4">
                  <h1 className="fw-bold leading-tight" style={{ fontSize: 'clamp(28px, 4vw, 44px)' }}>
                    Shaping Confident Learners for a Brighter Tomorrow
                  </h1>

                  <p className="opacity-75" style={{ fontSize: 'clamp(15px, 2vw, 18px)' }}>
                    At <strong>Krishna Public School</strong>, we provide
                    CBSE-aligned education that nurtures knowledge, values,
                    and character in a safe and supportive learning environment.
                  </p>

                  <p className="opacity-75" style={{ fontSize: 'clamp(15px, 2vw, 18px)' }} >
                    With experienced educators, modern infrastructure, and a
                    strong focus on holistic development, we prepare students
                    to succeed academically and grow into responsible citizens.
                  </p>

                  <div className="flex pt-3 gap-2">
                    <Button variant="contained" endIcon={<ArrowForward />}
                      sx={{ background: "linear-gradient(90deg, #dc2626, #ef4444)", padding: "12px 28px", fontSize: "16px", fontWeight: 600, borderRadius: "8px", textTransform: "none", }}
                        onClick={() => navigate(`/AdmissionForm?Type=AdmissionForm`)}>
                      Apply for Admission
                    </Button>
                    <Button variant="outlined" color='' onClick={() => setVideoOpen(true)} sx={{ padding: "12px 28px", fontSize: "16px", fontWeight: 600, borderRadius: "8px" }}>
                      Virtual Tour
                    </Button>
                  </div>
                </div>

                <div className="col-lg-5 d-flex justify-content-center mt-4 mt-lg-0">
                  <Lottie animationData={animationData} loop autoplay style={{ width: '100%', maxWidth: '420px' }} />
                </div>

              </div>
            </Container>
          </div>

          {images.map((image, index) => (
            <div key={index} className="carousel-item">
              <img src={`/Carousel/${image.CarouselURL}?timestamp=${new Date().getTime()}`}
                className="d-block w-100" style={{ objectFit: "cover", maxHeight: "600px" }} alt={image.CarouselTitle || "Krishna Public School"} />
            </div>
          ))}

        </div>

        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev" >
          <span className="carousel-control-prev-icon"></span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
          <span className="carousel-control-next-icon"></span>
        </button>
      </div>
      <Modal open={videoOpen} onClose={() => setVideoOpen(false)} className="flex items-center justify-center">
        <div className="bg-white rounded-2xl p-4 max-w-3xl w-full mx-4">
          <div className="aspect-video bg-gray-900 rounded-lg mb-4 flex items-center justify-center">
            <video src={Tour} controls autoPlay muted className="w-full h-full object-cover" />
          </div>
          <Button fullWidth variant="contained" onClick={() => setVideoOpen(false)} className="bg-gradient-to-r from-saffron-500 to-green-600" >
            Close
          </Button>
        </div>
      </Modal>
    </div>
  );
}
